export default __webpack_public_path__ + "static/media/beraksi-phone10.5d9fa988.png";